// Mock data for category landing pages. Products are placeholders until real
// products are added. Colours mirror the Shop by Category hub.

const bc = ["#E39A2B", "#2E8B57", "#D64B6A", "#E39A2B", "#2E8B57", "#C0314B"];
const bl = ["Best Seller", "New Launch", "Trending", "Best Seller", "New Launch", "Premium"];
const bestsellers = (items) =>
  items.map((p, i) => ({ ...p, badge: bl[i], badgeColor: bc[i] }));

const moreDefault = (first) => [
  { title: first.title, text: first.text, cta: "Explore Recipes" },
  { title: "Our quality standards", text: "Pure ingredients, no fillers, no artificial additives.", cta: "Learn More" },
  { title: "Explore more collections", text: "Seeds & Nuts, Plant Protein & Nutrition and other categories.", cta: "View All Collections", to: "/shop-by-category" },
];

export const CATEGORY_DATA = {
  "moringa-greens": {
    num: "01",
    name: "Moringa & Greens",
    subhead: "Nature's powerhouse for everyday nutrition.",
    desc: "Explore our pure, plant-based moringa and green superfoods, crafted to fuel your body, mind and natural well-being.",
    tint: "#DDE9C3", tintDeep: "#CBDFA6",
    heroImg: "/images/categories-landing/moringa-greens/hero.jpg",
    productImg: "/images/categories-landing/moringa-greens/product.jpg",
    featureImg: "/images/categories-landing/moringa-greens/product.jpg",
    sidebar: "Nature's green energy in every scoop",
    featurePanel: { title: "Moringa & Greens", lines: "Pure Plant Power.\nEveryday Greens." },
    tabs: [
      { label: "All Products", key: "all" }, { label: "Moringa", key: "moringa" }, { label: "Spirulina", key: "spirulina" },
      { label: "Wheatgrass", key: "wheatgrass" }, { label: "Chlorella", key: "chlorella" }, { label: "Green Blends", key: "green-blends" },
      { label: "Leaf Powders", key: "leaf-powders" }, { label: "Protein Blends", key: "protein-blends" },
      { label: "Detox Blends", key: "detox-blends" }, { label: "Immunity Blends", key: "immunity-blends" },
    ],
    products: [
      { name: "Moringa", sub: "Moringa Powder", rating: 4.8, count: 640, price: 449, tags: ["moringa"] },
      { name: "Spirulina", sub: "Spirulina Powder", rating: 4.6, count: 392, price: 549, tags: ["spirulina"] },
      { name: "Wheatgrass", sub: "Wheatgrass Powder", rating: 4.6, count: 392, price: 549, tags: ["wheatgrass"] },
      { name: "Green Blends", sub: "Green Superfood Blend", rating: 4.7, count: 256, price: 599, tags: ["green-blends"] },
      { name: "Chlorella", sub: "Chlorella Powder", rating: 4.6, count: 298, price: 599, tags: ["chlorella"] },
      { name: "Leaf Powders", sub: "Moringa Leaf Powder", rating: 4.7, count: 687, price: 449, tags: ["leaf-powders", "moringa"] },
      { name: "Protein Blends", sub: "Plant Protein Powder", rating: 4.6, count: 389, price: 699, tags: ["protein-blends"] },
      { name: "Detox Blends", sub: "Detox Green Blend", rating: 4.5, count: 399, price: 549, tags: ["detox-blends", "green-blends"] },
      { name: "Immunity Blends", sub: "Immunity Boost Blend", rating: 4.8, count: 250, price: 549, tags: ["immunity-blends", "green-blends"] },
      { name: "Moringa Tea", sub: "Moringa Herbal Tea", rating: 4.4, count: 102, price: 399, tags: ["moringa"] },
    ],
    why: {
      eyebrow: "Why Choose Our Moringa & Greens",
      title: ["Small Leaves.", "Big Benefits."],
      sub: "Packed with essential nutrients, antioxidants and plant power — for a healthier, stronger you.",
      items: [
        { icon: "leaf", title: "100% Natural Ingredients", text: "Pure. No compromises." },
        { icon: "sparkles", title: "Rich in Vitamins & Minerals", text: "Supports overall health." },
        { icon: "shield", title: "Powerful Antioxidants", text: "Fights free radicals." },
        { icon: "sprout", title: "Plant-Based Goodness", text: "Kind to your body." },
      ],
    },
    bestsellers: bestsellers([
      { name: "Moringa Powder", rating: 4.8, count: 260, price: 449 },
      { name: "Spirulina Powder", rating: 4.6, count: 980, price: 549 },
      { name: "Wheatgrass Powder", rating: 4.6, count: 892, price: 549 },
      { name: "Chlorella Powder", rating: 4.6, count: 642, price: 599 },
      { name: "Moringa Tea", rating: 4.4, count: 400, price: 399 },
      { name: "Green Superfood Blend", rating: 4.6, count: 530, price: 599 },
    ]),
    more: moreDefault({ title: "How to use green powders", text: "Simple recipes, ideas for smoothies, drinks, and everyday meals." }),
  },

  "adaptogens-herbs": {
    num: "02",
    name: "Adaptogens & Herbs",
    subhead: "Balance. Focus. Inner strength.",
    desc: "Discover nature-inspired herbs and adaptogens for your everyday wellness rituals.",
    tint: "#F6E6BE", tintDeep: "#F3DC96",
    heroImg: "/images/adaptogens/hero.jpg",
    productImg: "/images/adaptogens/pouch.jpg",
    featureImg: "/images/adaptogens/feature.jpg",
    sidebar: "Ancient wisdom in every scoop",
    featurePanel: { title: "Adaptogens & Herbs", lines: "Rooted in Nature.\nMade for Balance." },
    tabs: [
      { label: "All Products", key: "all" }, { label: "Ashwagandha", key: "ashwagandha" }, { label: "Tulsi", key: "tulsi" },
      { label: "Brahmi", key: "brahmi" }, { label: "Moringa Herbal Tea", key: "moringa-tea" }, { label: "Herbal Blends", key: "herbal-blends" },
      { label: "Adaptogen Blends", key: "adaptogen-blends" }, { label: "Daily Wellness", key: "daily-wellness" },
    ],
    products: [
      { name: "Ashwagandha Powder", sub: "Ashwagandha Powder", rating: 4.7, count: 6412, price: 499, tags: ["ashwagandha"] },
      { name: "Tulsi Leaf Powder", sub: "Tulsi Leaf Powder", rating: 4.6, count: 6421, price: 349, tags: ["tulsi"] },
      { name: "Brahmi Powder", sub: "Brahmi Powder", rating: 4.5, count: 2196, price: 399, tags: ["brahmi"] },
      { name: "Adaptogen Blend", sub: "Adaptogen Blend", rating: 4.8, count: 827, price: 599, tags: ["adaptogen-blends"] },
      { name: "Herbal Wellness Tea", sub: "Herbal Wellness Tea", rating: 4.6, count: 2198, price: 399, tags: ["moringa-tea", "herbal-blends"] },
      { name: "Ashwagandha Capsules", sub: "Ashwagandha Capsules", rating: 4.6, count: 867, price: 549, tags: ["ashwagandha"] },
      { name: "Tulsi Herbal Tea", sub: "Tulsi Herbal Tea", rating: 4.6, count: 306, price: 299, tags: ["tulsi", "moringa-tea"] },
      { name: "Brahmi & Gotu Kola Blend", sub: "Brahmi & Gotu Kola Blend", rating: 4.6, count: 503, price: 449, tags: ["brahmi", "herbal-blends"] },
      { name: "Daily Balance Blend", sub: "Daily Balance Blend", rating: 4.6, count: 430, price: 599, tags: ["daily-wellness", "adaptogen-blends"] },
      { name: "Calm Within Herbal Tea", sub: "Calm Within Herbal Tea", rating: 4.6, count: 720, price: 349, tags: ["herbal-blends", "daily-wellness"] },
    ],
    why: {
      eyebrow: "Why Choose Our Adaptogens & Herbs",
      title: ["Natural Balance.", "Everyday Wellness."],
      sub: "Ancient wisdom. Modern wellness. Pure, plant-based goodness.",
      items: [
        { icon: "leaf", title: "100% Natural Ingredients", text: "Pure. No compromises." },
        { icon: "sparkles", title: "Rich in Adaptogens", text: "Natural resilience." },
        { icon: "shield", title: "Powerful Antioxidants", text: "Fight free radicals." },
        { icon: "sprout", title: "Plant-Based Goodness", text: "Nature's pure boost." },
      ],
    },
    bestsellers: bestsellers([
      { name: "Ashwagandha Powder", rating: 4.6, count: 6412, price: 499 },
      { name: "Tulsi Herbal Tea", rating: 4.6, count: 306, price: 299 },
      { name: "Brahmi Powder", rating: 4.5, count: 2196, price: 399 },
      { name: "Adaptogen Blend", rating: 4.8, count: 827, price: 599 },
      { name: "Herbal Wellness Tea", rating: 4.6, count: 2198, price: 349 },
      { name: "Daily Balance Blend", rating: 4.6, count: 430, price: 599 },
    ]),
    more: moreDefault({ title: "How to use adaptogens", text: "Simple recipes, teas, or smoothies, drinks, and everyday foods." }),
  },

  "seeds-nuts": {
    num: "03",
    name: "Seeds & Nuts",
    subhead: "Small bites. Big benefits.",
    desc: "Packed with essential nutrients, healthy fats and natural goodness for a stronger you.",
    tint: "#F9D9DC", tintDeep: "#F6C6CC",
    heroImg: "/images/categories-landing/seeds-nuts/hero.jpg",
    productImg: "/images/categories-landing/seeds-nuts/product.jpg",
    featureImg: "/images/categories-landing/seeds-nuts/product.jpg",
    sidebar: "Nature's power-packed snacks",
    featurePanel: { title: "Seeds & Nuts", lines: "Small Bites.\nBig Nutrition." },
    tabs: [
      { label: "All Products", key: "all" }, { label: "Seeds", key: "seeds" }, { label: "Nuts", key: "nuts" },
      { label: "Superfood Blends", key: "superfood-blends" }, { label: "Healthy Snacks", key: "healthy-snacks" },
      { label: "Trail Mixes", key: "trail-mixes" }, { label: "Dry Fruits", key: "dry-fruits" }, { label: "Protein Blends", key: "protein-blends" },
    ],
    products: [
      { name: "Chia Seeds", sub: "Chia Seeds", rating: 4.7, count: 541, price: 349, tags: ["seeds"] },
      { name: "Flax Seeds", sub: "Flax Seeds", rating: 4.6, count: 782, price: 299, tags: ["seeds"] },
      { name: "Pumpkin Seeds", sub: "Pumpkin Seeds", rating: 4.6, count: 982, price: 349, tags: ["seeds"] },
      { name: "Sunflower Seeds", sub: "Sunflower Seeds", rating: 4.6, count: 981, price: 299, tags: ["seeds"] },
      { name: "Almonds", sub: "Almonds", rating: 4.6, count: 1013, price: 599, tags: ["nuts", "dry-fruits"] },
      { name: "Cashew", sub: "Cashew", rating: 4.6, count: 1013, price: 549, tags: ["nuts", "dry-fruits"] },
      { name: "Walnuts", sub: "Walnuts", rating: 4.6, count: 1013, price: 549, tags: ["nuts", "dry-fruits"] },
      { name: "Mixed Nuts & Seeds", sub: "Mixed Nuts & Seeds", rating: 4.6, count: 1031, price: 649, tags: ["nuts", "seeds", "trail-mixes", "superfood-blends"] },
      { name: "Brazil Nuts", sub: "Brazil Nuts", rating: 4.6, count: 1031, price: 399, tags: ["nuts"] },
      { name: "Goji Berries", sub: "Goji Berries", rating: 4.6, count: 1206, price: 449, tags: ["dry-fruits", "healthy-snacks"] },
    ],
    why: {
      eyebrow: "Why Choose Our Seeds & Nuts",
      title: ["Natural Balance.", "Everyday Wellness."],
      sub: "Rich in protein, fiber, and healthy fats — for more energy, better focus and long-lasting health.",
      items: [
        { icon: "dumbbell", title: "Rich in Protein", text: "Helps with muscle health & satiety." },
        { icon: "heart", title: "Healthy Fats", text: "Supports heart health." },
        { icon: "sprout", title: "High in Fiber", text: "Improves digestion & keeps you full." },
        { icon: "sparkles", title: "Vitamins & Minerals", text: "Boosts immunity & energy." },
        { icon: "star", title: "Great Taste", text: "Seeds & nuts, trusted by all." },
      ],
    },
    bestsellers: bestsellers([
      { name: "Mixed Nuts & Seeds", rating: 4.6, count: 1013, price: 649 },
      { name: "Chia Seeds", rating: 4.6, count: 1013, price: 349 },
      { name: "Flax Seeds", rating: 4.6, count: 981, price: 299 },
      { name: "Almonds", rating: 4.5, count: 798, price: 599 },
      { name: "Pumpkin Seeds", rating: 4.6, count: 1120, price: 349 },
      { name: "Organic Dry Fruits", rating: 4.6, count: 207, price: 599 },
    ]),
    more: moreDefault({ title: "Add to Smoothies, Bowls & Recipes", text: "Simple ideas for everyday healthy meals." }),
  },

  "superfood-blends": {
    num: "04",
    name: "Superfood Blends",
    subhead: "Powerful blends for complete nutrition.",
    desc: "Nutrient-dense superfood blends crafted to support your energy, immunity and everyday wellness.",
    tint: "#CDE5F0", tintDeep: "#B5D8EA",
    heroImg: "/images/categories-landing/superfood-blends/hero.jpg",
    productImg: "/images/categories-landing/superfood-blends/product.jpg",
    featureImg: "/images/categories-landing/superfood-blends/product.jpg",
    sidebar: "Nature's best in every scoop",
    featurePanel: { title: "Superfood Blends", lines: "Nature's Best.\nIn One Scoop." },
    tabs: [
      { label: "All Products", key: "all" }, { label: "Berry Blends", key: "berry-blends" }, { label: "Green Blends", key: "green-blends" },
      { label: "Protein Blends", key: "protein-blends" }, { label: "Antioxidant", key: "antioxidant" }, { label: "Detox", key: "detox" },
      { label: "Immunity", key: "immunity" }, { label: "Daily Wellness", key: "daily-wellness" },
    ],
    products: [
      { name: "Acai Berry Blend", sub: "Acai Berry Blend", rating: 4.7, count: 512, price: 649, tags: ["berry-blends", "antioxidant"] },
      { name: "Green Superfood Blend", sub: "Green Superfood Blend", rating: 4.6, count: 684, price: 599, tags: ["green-blends"] },
      { name: "Antioxidant Mix", sub: "Antioxidant Mix", rating: 4.6, count: 398, price: 629, tags: ["antioxidant"] },
      { name: "Daily Wellness Blend", sub: "Daily Wellness Blend", rating: 4.7, count: 421, price: 579, tags: ["daily-wellness"] },
      { name: "Immunity Super Blend", sub: "Immunity Super Blend", rating: 4.8, count: 356, price: 649, tags: ["immunity"] },
      { name: "Protein Superfood Mix", sub: "Protein Superfood Mix", rating: 4.6, count: 289, price: 699, tags: ["protein-blends"] },
      { name: "Detox Berry Blend", sub: "Detox Berry Blend", rating: 4.5, count: 312, price: 629, tags: ["detox", "berry-blends"] },
      { name: "Cacao & Maca Blend", sub: "Cacao & Maca Blend", rating: 4.6, count: 267, price: 679, tags: ["antioxidant"] },
      { name: "Golden Turmeric Blend", sub: "Golden Turmeric Blend", rating: 4.6, count: 430, price: 549, tags: ["daily-wellness", "immunity"] },
      { name: "Berry Antioxidant Powder", sub: "Berry Antioxidant Powder", rating: 4.6, count: 198, price: 599, tags: ["berry-blends", "antioxidant"] },
    ],
    why: {
      eyebrow: "Why Choose Our Superfood Blends",
      title: ["Complete Nutrition.", "In Every Scoop."],
      sub: "Powerful combinations of nature's best superfoods for complete daily nutrition.",
      items: [
        { icon: "leaf", title: "100% Natural", text: "Pure, clean blends." },
        { icon: "shield", title: "Antioxidant Rich", text: "Fights free radicals." },
        { icon: "sparkles", title: "Nutrient Dense", text: "Everything in one scoop." },
        { icon: "sprout", title: "Plant-Based", text: "Kind to your body." },
      ],
    },
    bestsellers: bestsellers([
      { name: "Acai Berry Blend", rating: 4.7, count: 512, price: 649 },
      { name: "Green Superfood Blend", rating: 4.6, count: 684, price: 599 },
      { name: "Immunity Super Blend", rating: 4.8, count: 356, price: 649 },
      { name: "Golden Turmeric Blend", rating: 4.6, count: 430, price: 549 },
      { name: "Antioxidant Mix", rating: 4.6, count: 398, price: 629 },
      { name: "Protein Superfood Mix", rating: 4.6, count: 289, price: 699 },
    ]),
    more: moreDefault({ title: "Add to Smoothies, Bowls & Recipes", text: "Simple ideas for everyday healthy meals." }),
  },

  "proteins-plant-powders": {
    num: "05",
    name: "Proteins & Plant Powders",
    subhead: "Fuel your body, naturally.",
    desc: "Clean, plant-based protein powders to help you build strength, recover and stay energised.",
    tint: "#FBDFC9", tintDeep: "#F8CDAD",
    heroImg: "/images/categories-landing/proteins-plant-powders/hero.jpg",
    productImg: "/images/categories-landing/proteins-plant-powders/product.jpg",
    featureImg: "/images/categories-landing/proteins-plant-powders/product.jpg",
    sidebar: "Clean protein in every scoop",
    featurePanel: { title: "Proteins & Powders", lines: "Clean Protein.\nPure Strength." },
    tabs: [
      { label: "All Products", key: "all" }, { label: "Plant Protein", key: "plant-protein" }, { label: "Pea Protein", key: "pea-protein" },
      { label: "Protein Blends", key: "protein-blends" }, { label: "Meal Replacement", key: "meal-replacement" },
      { label: "Protein Powders", key: "protein-powders" }, { label: "Daily Nutrition", key: "daily-nutrition" },
    ],
    products: [
      { name: "Plant Protein", sub: "Chocolate", rating: 4.8, count: 642, price: 799, tags: ["plant-protein", "protein-powders"] },
      { name: "Plant Protein", sub: "Vanilla", rating: 4.7, count: 589, price: 799, tags: ["plant-protein", "protein-powders"] },
      { name: "Pea Protein Powder", sub: "Pea Protein Powder", rating: 4.6, count: 482, price: 749, tags: ["pea-protein"] },
      { name: "Brown Rice Protein", sub: "Brown Rice Protein", rating: 4.5, count: 398, price: 699, tags: ["plant-protein"] },
      { name: "Protein Blend", sub: "Unflavoured", rating: 4.6, count: 409, price: 729, tags: ["protein-blends"] },
      { name: "Meal Replacement Shake", sub: "Meal Replacement", rating: 4.7, count: 356, price: 849, tags: ["meal-replacement"] },
      { name: "Hemp Protein Powder", sub: "Hemp Protein Powder", rating: 4.6, count: 312, price: 779, tags: ["plant-protein"] },
      { name: "Soy Protein Isolate", sub: "Soy Protein Isolate", rating: 4.5, count: 287, price: 699, tags: ["plant-protein"] },
      { name: "Daily Protein Mix", sub: "Daily Protein Mix", rating: 4.6, count: 430, price: 729, tags: ["daily-nutrition", "protein-blends"] },
      { name: "Sprouted Protein Powder", sub: "Sprouted Protein Powder", rating: 4.6, count: 246, price: 799, tags: ["plant-protein"] },
    ],
    why: {
      eyebrow: "Why Choose Our Plant Proteins",
      title: ["Strength.", "Naturally Fueled."],
      sub: "Clean plant-based protein to fuel your body, build strength and recover better.",
      items: [
        { icon: "sprout", title: "Plant-Based Protein", text: "Clean & complete." },
        { icon: "dumbbell", title: "Muscle Support", text: "Build & recover." },
        { icon: "heart", title: "Easy to Digest", text: "Gentle on your gut." },
        { icon: "leaf", title: "No Additives", text: "Pure & simple." },
      ],
    },
    bestsellers: bestsellers([
      { name: "Plant Protein (Chocolate)", rating: 4.8, count: 642, price: 799 },
      { name: "Plant Protein (Vanilla)", rating: 4.7, count: 589, price: 799 },
      { name: "Pea Protein Powder", rating: 4.6, count: 482, price: 749 },
      { name: "Meal Replacement Shake", rating: 4.7, count: 356, price: 849 },
      { name: "Hemp Protein Powder", rating: 4.6, count: 312, price: 779 },
      { name: "Daily Protein Mix", rating: 4.6, count: 430, price: 729 },
    ]),
    more: moreDefault({ title: "Add to Smoothies, Shakes & Recipes", text: "Simple ideas for everyday protein-rich meals." }),
  },

  "wellness-essentials": {
    num: "06",
    name: "Wellness Essentials",
    subhead: "Everyday wellness, made simple.",
    desc: "Functional gummies, nectars and supplements crafted from pure, natural ingredients for daily wellbeing.",
    tint: "#E6DBF3", tintDeep: "#D8C8EC",
    heroImg: "/images/categories-landing/wellness-essentials/hero.jpg",
    productImg: "/images/categories-landing/wellness-essentials/product.jpg",
    featureImg: "/images/categories-landing/wellness-essentials/product.jpg",
    sidebar: "Daily wellness in every dose",
    featurePanel: { title: "Wellness Essentials", lines: "Daily Wellness.\nMade Simple." },
    tabs: [
      { label: "All Products", key: "all" }, { label: "Gummies", key: "gummies" }, { label: "Nectars", key: "nectars" },
      { label: "Supplements", key: "supplements" }, { label: "Herbal", key: "herbal" }, { label: "Daily Wellness", key: "daily-wellness" },
      { label: "Immunity", key: "immunity" }, { label: "Sleep", key: "sleep" },
    ],
    products: [
      { name: "Immunity Gummies", sub: "Immunity Gummies", rating: 4.6, count: 482, price: 699, tags: ["gummies", "immunity"] },
      { name: "Multivitamin Gummies", sub: "Multivitamin Gummies", rating: 4.7, count: 521, price: 699, tags: ["gummies"] },
      { name: "Sleep Support Gummies", sub: "Sleep Support Gummies", rating: 4.5, count: 312, price: 729, tags: ["gummies", "sleep"] },
      { name: "Apple Cider Nectar", sub: "Apple Cider Nectar", rating: 4.6, count: 398, price: 549, tags: ["nectars"] },
      { name: "Turmeric Nectar", sub: "Turmeric Nectar", rating: 4.6, count: 356, price: 549, tags: ["nectars", "immunity"] },
      { name: "Herbal Immunity Drops", sub: "Herbal Immunity Drops", rating: 4.5, count: 289, price: 499, tags: ["herbal", "immunity"] },
      { name: "Daily Wellness Capsules", sub: "Daily Wellness Capsules", rating: 4.6, count: 430, price: 599, tags: ["supplements", "daily-wellness"] },
      { name: "Hair & Skin Gummies", sub: "Hair & Skin Gummies", rating: 4.7, count: 512, price: 749, tags: ["gummies"] },
      { name: "Stress Relief Blend", sub: "Stress Relief Blend", rating: 4.6, count: 267, price: 629, tags: ["herbal", "sleep"] },
      { name: "Energy Boost Nectar", sub: "Energy Boost Nectar", rating: 4.6, count: 345, price: 579, tags: ["nectars", "daily-wellness"] },
    ],
    why: {
      eyebrow: "Why Choose Our Wellness Essentials",
      title: ["Feel Good.", "Every Day."],
      sub: "Functional gummies, nectars and daily wellness made from pure, natural ingredients.",
      items: [
        { icon: "leaf", title: "100% Natural", text: "No nasties." },
        { icon: "heart", title: "Daily Wellness", text: "Supports your routine." },
        { icon: "sparkles", title: "Functional Benefits", text: "Targeted support." },
        { icon: "shield", title: "Trusted Quality", text: "Made with care." },
      ],
    },
    bestsellers: bestsellers([
      { name: "Immunity Gummies", rating: 4.6, count: 482, price: 699 },
      { name: "Multivitamin Gummies", rating: 4.7, count: 521, price: 699 },
      { name: "Apple Cider Nectar", rating: 4.6, count: 398, price: 549 },
      { name: "Hair & Skin Gummies", rating: 4.7, count: 512, price: 749 },
      { name: "Turmeric Nectar", rating: 4.6, count: 356, price: 549 },
      { name: "Sleep Support Gummies", rating: 4.5, count: 312, price: 729 },
    ]),
    more: moreDefault({ title: "Build Your Daily Routine", text: "Simple ways to add wellness to every day." }),
  },

  "kids-nutrition": {
    num: "07",
    name: "Kids Nutrition",
    subhead: "Healthy Habits. Happier Tomorrows.",
    desc: "Nutritious, natural and made with love. Our kids' range supports growth, immunity and brain development.",
    tint: "#C4E7E2", tintDeep: "#AEDED7",
    heroImg: "/images/categories-landing/kids-nutrition/hero.jpg",
    productImg: "/images/categories-landing/kids-nutrition/product.jpg",
    featureImg: "/images/categories-landing/kids-nutrition/product.jpg",
    sidebar: "Healthy choices for growing minds & bodies",
    featurePanel: { title: "Kids Nutrition", lines: "Healthy Habits.\nHappy Kids." },
    tabs: [
      { label: "All Products", key: "all" }, { label: "Kids Protein", key: "kids-protein" }, { label: "Kids Gummies", key: "kids-gummies" },
      { label: "Superfood Mixes", key: "superfood-mixes" }, { label: "Healthy Snacks", key: "healthy-snacks" },
      { label: "Supplements", key: "supplements" }, { label: "Beverages", key: "beverages" }, { label: "Organic Foods", key: "organic-foods" },
    ],
    products: [
      { name: "Kids Protein Powder", sub: "Chocolate", rating: 4.8, count: 642, price: 799, tags: ["kids-protein"] },
      { name: "Kids Protein Powder", sub: "Vanilla", rating: 4.7, count: 589, price: 799, tags: ["kids-protein"] },
      { name: "Immunity Gummies", sub: "Orange Flavour", rating: 4.6, count: 482, price: 699, tags: ["kids-gummies", "supplements"] },
      { name: "Focus Gummies", sub: "Blueberry Flavour", rating: 4.5, count: 398, price: 699, tags: ["kids-gummies"] },
      { name: "Growth Gummies", sub: "Strawberry Flavour", rating: 4.6, count: 409, price: 699, tags: ["kids-gummies"] },
      { name: "Superfood Mix", sub: "Chocolate", rating: 4.7, count: 356, price: 749, tags: ["superfood-mixes"] },
      { name: "Superfood Mix", sub: "Vanilla", rating: 4.6, count: 443, price: 749, tags: ["superfood-mixes"] },
      { name: "Healthy Snacks", sub: "Apple & Cinnamon", rating: 4.4, count: 312, price: 499, tags: ["healthy-snacks", "organic-foods"] },
      { name: "Organic Dry Fruits", sub: "Mixed Berries", rating: 4.6, count: 287, price: 599, tags: ["organic-foods", "healthy-snacks"] },
      { name: "Kids Beverage", sub: "Mango", rating: 4.3, count: 246, price: 399, tags: ["beverages"] },
    ],
    why: {
      eyebrow: "Why Choose Our Kids Nutrition",
      title: ["Stronger Kids.", "Brighter Futures."],
      sub: "Thoughtfully crafted with natural ingredients to fuel their growth, immunity and brain development.",
      items: [
        { icon: "shield", title: "Boosts Immunity", text: "Helps them stay healthy & active." },
        { icon: "brain", title: "Supports Brain Development", text: "Fuel for learning & focus." },
        { icon: "sprout", title: "Healthy Growth", text: "Builds strong bones & muscles." },
        { icon: "leaf", title: "No Artificial Additives", text: "Pure, clean nutrition." },
        { icon: "heart", title: "Great Taste", text: "Kids love it, parents trust it." },
      ],
    },
    bestsellers: bestsellers([
      { name: "Kids Protein Powder (Chocolate)", rating: 4.8, count: 642, price: 799 },
      { name: "Immunity Gummies (Orange)", rating: 4.6, count: 482, price: 699 },
      { name: "Superfood Mix (Vanilla)", rating: 4.6, count: 643, price: 749 },
      { name: "Kids Gummies (Blueberry)", rating: 4.5, count: 398, price: 699 },
      { name: "Healthy Snacks (Apple & Cinnamon)", rating: 4.4, count: 312, price: 499 },
      { name: "Organic Dry Fruits (Mixed Berries)", rating: 4.6, count: 287, price: 599 },
    ]),
    more: moreDefault({ title: "Add to Smoothies, Bowls & Recipes", text: "Simple ideas for everyday healthy meals." }),
  },

  "pickles-chutneys": {
    num: "08",
    name: "Pickles & Chutneys",
    subhead: "Traditional Flavours. Pure Goodness.",
    desc: "Authentic recipes, natural ingredients and bold flavours — crafted to bring the taste of tradition to your table, every day.",
    tint: "#F9D3DA", tintDeep: "#F6BEC8",
    heroImg: "/images/categories-landing/pickles-chutneys/hero.jpg",
    productImg: "/images/categories-landing/pickles-chutneys/product.jpg",
    featureImg: "/images/categories-landing/pickles-chutneys/product.jpg",
    sidebar: "Handcrafted with the finest natural ingredients",
    featurePanel: { title: "Pickles & Chutneys", lines: "Timeless Recipes.\nNatural Ingredients." },
    tabs: [
      { label: "All Products", key: "all" }, { label: "Pickles", key: "pickles" }, { label: "Chutneys", key: "chutneys" },
      { label: "Spreads", key: "spreads" }, { label: "Brinjal", key: "brinjal" }, { label: "Tomato", key: "tomato" },
      { label: "Mango", key: "mango" }, { label: "Mixed Veg", key: "mixed-veg" }, { label: "Traditional", key: "traditional" },
    ],
    products: [
      { name: "Mango Pickle", sub: "Traditional Recipe", rating: 4.8, count: 642, price: 249, tags: ["pickles", "mango", "traditional"] },
      { name: "Mixed Veg Pickle", sub: "Mixed Veg Pickle", rating: 4.7, count: 521, price: 229, tags: ["pickles", "mixed-veg"] },
      { name: "Lemon Pickle", sub: "Lemon Pickle", rating: 4.6, count: 498, price: 199, tags: ["pickles", "traditional"] },
      { name: "Green Chilli Pickle", sub: "Green Chilli Pickle", rating: 4.5, count: 433, price: 199, tags: ["pickles"] },
      { name: "Tomato Chutney", sub: "Homemade Style", rating: 4.6, count: 407, price: 179, tags: ["chutneys", "tomato"] },
      { name: "Ginger Chutney", sub: "Ginger Chutney", rating: 4.7, count: 356, price: 169, tags: ["chutneys"] },
      { name: "Garlic Chutney", sub: "Garlic Chutney", rating: 4.6, count: 443, price: 169, tags: ["chutneys"] },
      { name: "Coriander Chutney", sub: "Coriander Chutney", rating: 4.4, count: 312, price: 149, tags: ["chutneys"] },
      { name: "Mint Chutney", sub: "Mint Chutney", rating: 4.5, count: 287, price: 149, tags: ["chutneys"] },
      { name: "Spicy Spread", sub: "Spicy Spread", rating: 4.3, count: 246, price: 139, tags: ["spreads"] },
    ],
    why: {
      eyebrow: "Why Choose Our Pickles & Chutneys?",
      title: ["Pure. Traditional.", "Full of Flavour."],
      sub: "Made with natural ingredients, traditional recipes and no artificial preservatives.",
      items: [
        { icon: "leaf", title: "100% Natural Ingredients", text: "Pure. Clean. Natural." },
        { icon: "sprout", title: "Traditional Recipes", text: "Passed down for generations." },
        { icon: "flame", title: "No Preservatives", text: "Just pure, natural goodness." },
        { icon: "sparkles", title: "Rich in Flavour", text: "Authentic taste in every bite." },
        { icon: "heart", title: "Small Batches", text: "Handcrafted with care." },
      ],
    },
    bestsellers: bestsellers([
      { name: "Mango Pickle", rating: 4.8, count: 642, price: 249 },
      { name: "Mixed Veg Pickle", rating: 4.7, count: 521, price: 229 },
      { name: "Tomato Chutney", rating: 4.6, count: 407, price: 179 },
      { name: "Green Chilli Pickle", rating: 4.5, count: 433, price: 199 },
      { name: "Garlic Chutney", rating: 4.6, count: 443, price: 169 },
      { name: "Mint Chutney", rating: 4.3, count: 287, price: 149 },
    ]),
    more: moreDefault({ title: "Pair with Every Meal", text: "Simple ideas to add flavour to everyday meals." }),
  },

  gifting: {
    num: "09",
    name: "Gifting",
    subhead: "Thoughtful. Healthy. Always Special.",
    desc: "Premium superfoods, beautifully packed for every occasion. Because the best gifts come from nature.",
    tint: "#F6E3A0", tintDeep: "#F2D878",
    heroImg: "/images/categories-landing/gifting/hero.jpg",
    productImg: "/images/categories-landing/gifting/product.jpg",
    featureImg: "/images/categories-landing/gifting/product.jpg",
    sidebar: "Perfect gifts for every occasion",
    featurePanel: { title: "Gifting", lines: "Thoughtful Gifts.\nNaturally Special." },
    tabs: [
      { label: "All Products", key: "all" }, { label: "Gift Hampers", key: "gift-hampers" }, { label: "Dry Fruit Boxes", key: "dry-fruit-boxes" },
      { label: "Healthy Snacks Hampers", key: "healthy-snacks-hampers" }, { label: "Festive Special", key: "festive-special" },
      { label: "Corporate Gifting", key: "corporate-gifting" }, { label: "Custom Hampers", key: "custom-hampers" },
    ],
    products: [
      { name: "Premium Dry Fruit Gift Hamper", sub: "Gift Hamper", rating: 4.8, count: 642, price: 1299, tags: ["gift-hampers", "dry-fruit-boxes"] },
      { name: "Healthy Snacks Gift Box", sub: "Gift Box", rating: 4.7, count: 521, price: 899, tags: ["healthy-snacks-hampers"] },
      { name: "Assorted Nuts Gift Pack", sub: "Gift Pack", rating: 4.6, count: 398, price: 1099, tags: ["dry-fruit-boxes", "gift-hampers"] },
      { name: "Festive Special Gift Hamper", sub: "Gift Hamper", rating: 4.8, count: 730, price: 1499, tags: ["festive-special"] },
      { name: "Corporate Gift Box", sub: "Gift Box", rating: 4.5, count: 412, price: 1299, tags: ["corporate-gifting"] },
      { name: "Trail Mix Gift Jar", sub: "Gift Jar", rating: 4.6, count: 367, price: 749, tags: ["healthy-snacks-hampers"] },
      { name: "Dry Fruits & Seeds Gift Box", sub: "Gift Box", rating: 4.7, count: 589, price: 1199, tags: ["dry-fruit-boxes"] },
      { name: "Mixed Nuts Hamper", sub: "Hamper", rating: 4.6, count: 482, price: 999, tags: ["gift-hampers"] },
      { name: "Wellness Gift Pack", sub: "Gift Pack", rating: 4.7, count: 640, price: 1399, tags: ["custom-hampers", "festive-special"] },
      { name: "Custom Gift Hamper", sub: "Custom Hamper", rating: 4.5, count: 331, price: 1199, tags: ["custom-hampers"] },
    ],
    why: {
      eyebrow: "Why Choose Our Gifting Range",
      title: ["More Than Just", "a Gift."],
      sub: "Thoughtfully curated. Naturally delicious. Perfect for every celebration.",
      items: [
        { icon: "gift", title: "Premium Packaging", text: "Looks as good as it tastes." },
        { icon: "leaf", title: "100% Natural Ingredients", text: "Pure. Wholesome. Safe." },
        { icon: "heart", title: "Thoughtful Selections", text: "For every occasion and relationship." },
        { icon: "star", title: "Trusted Quality", text: "Because they deserve the best." },
      ],
    },
    bestsellers: bestsellers([
      { name: "Premium Dry Fruit Hamper", rating: 4.8, count: 642, price: 1299 },
      { name: "Healthy Snacks Gift Box", rating: 4.7, count: 521, price: 899 },
      { name: "Mixed Nuts Gift Pack", rating: 4.6, count: 482, price: 999 },
      { name: "Festive Special Hamper", rating: 4.8, count: 730, price: 1499 },
      { name: "Trail Mix Gift Jar", rating: 4.6, count: 367, price: 749 },
      { name: "Corporate Gift Box", rating: 4.5, count: 412, price: 1299 },
    ]),
    more: [
      { title: "Gift for Every Occasion", text: "Birthdays, festivals, anniversaries and more — make every moment healthier and happier.", cta: "Explore Gifts" },
      { title: "Custom Gifting", text: "Personalised hampers for corporate and special events.", cta: "Learn More" },
      { title: "Explore Our Collection", text: "Curated gift sets with the goodness of nature's finest.", cta: "View All Collections", to: "/shop-by-category" },
    ],
  },
};
